import { topbarStyles } from "../../commonStyle/TopStyles";
export const primaryColor = "#179b9b";
export const whiteColor = "#ffffff";
export const extendedStyles = {
  topbarContainer: {
    ...topbarStyles.topbarContainer,
    backgroundColor: whiteColor,
    boxShadow: "0px 2px 10px rgba(23, 155, 155, 0.2)",
    borderRadius: "4px",
    marginBottom: "16px",
  },
};

export const clearAllStorage = () => {
  const itemsToRemove = ["authToken", "user", "permissions"];
  itemsToRemove.forEach((item) => localStorage.removeItem(item));

  localStorage.clear();
  sessionStorage.clear();
};
export const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};

export const dialogVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
    },
  },
  exit: {
    opacity: 0,
    y: 20,
    scale: 0.95,
    transition: { duration: 0.2 },
  },
};

export const iconVariants = {
  initial: { rotate: 0 },
  animate: { rotate: 360, transition: { duration: 1 } },
};

export const loginStyleS = {
  ButtonLogout: {
    fontWeight: "medium",
    fontSize: "14px",
    textTransform: "none",
    color: whiteColor,
    backgroundColor: primaryColor,
    "&:hover": {
      backgroundColor: primaryColor,
      opacity: 0.9,
      boxShadow: "0px 4px 8px rgba(23, 155, 155, 0.3)",
    },
  },
  motion_div: {
    borderRadius: "8px",
    overflow: "hidden",
    width: "100%",
    maxWidth: "400px",
  },
  motion_div2: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(248, 249, 249, 0.27)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialogTitle: {
    backgroundColor: primaryColor,
    color: whiteColor,
    borderBottom: "2px solid rgba(255, 255, 255, 0.2)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  contentBox2: {
    borderColor: primaryColor,
    color: primaryColor,
    fontWeight: "bold",
    minWidth: "120px",
    "&:hover": {
      borderColor: primaryColor,
      backgroundColor: "rgba(23, 155, 155, 0.05)",
    },
  },
  contentBox: {
    padding: 3,
    backgroundColor: whiteColor,
    borderTop: `1px solid rgba(23, 155, 155, 0.2)`,
    display: "flex",
    justifyContent: "center",
    gap: 3,
  },
  contentBoxButton: {
    backgroundColor: primaryColor,
    color: whiteColor,
    fontWeight: "bold",
    minWidth: "120px",
    "&:hover": {
      backgroundColor: primaryColor,
      opacity: 0.9,
      boxShadow: "0px 4px 8px rgba(23, 155, 155, 0.3)",
    },
  },
};
